/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { FollowResponse, FollowVars } from '../openapi-types.gen.js';

export type { FollowResponse, FollowVars } from '../openapi-types.gen.js';

export const useFollow = createMutationHook<FollowVars, FollowResponse, unknown>({
  specName: 'useFollow',
  path: '/v1/users/{userId}/follows',
  method: 'POST',
  resolveUrl: (vars: FollowVars) => `/v1/users/${vars.userId}/follows`,
  
  parseResponse: (raw: unknown): FollowResponse => raw as FollowResponse,
  optimistic: [{
    queryKey: ['users', 'follow-counts'],
    apply: (prev: any, vars: FollowVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyFollowCountsOptimistic as unknown as (prev: any, vars: FollowVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  viewerRelationship: {"kind":"follow","targetArg":"userId","active":true} as const,
  
});
